import { LiquidSwell } from '../..';

// {{ form | payment_terms }}

export default function bind(_liquidSwell: LiquidSwell) {
  return (form: any) => {
    // TODO
    return null;
  };
}
